import { render } from "./MultipleChoiceType.vue?vue&type=template&id=bf565f2c"
import script from "./MultipleChoiceType.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceType.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/interfaces/interfaces/apps/flowform/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__